import { useEffect, useState } from 'react';
import type { Expense } from '@/lib/types';
import { useRepositories } from '@/context/RepositoryContext';
import { invalidateExpenses, subscribeExpenses } from './expensesStore';

export function useExpenses(): { expenses: Expense[]; loading: boolean; reload: () => void } {
  const { expenseRepository } = useRepositories();
  const [expenses, setExpenses] = useState<Expense[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    const load = () => {
      expenseRepository.listExpenses().then((data) => {
        if (!active) return;
        setExpenses(data);
        setLoading(false);
      });
    };
    load();
    const unsubscribe = subscribeExpenses(load);
    return () => {
      active = false;
      unsubscribe();
    };
  }, [expenseRepository]);

  return { expenses, loading, reload: invalidateExpenses };
}
